import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-soft-lg py-3 transform -translate-y-1' : 'bg-transparent py-6'
    }`}>
      <div className="container flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img 
            src="https://salonrenter.com/wp-content/uploads/2025/05/new-snap-launch-logo.png" 
            alt="Snap Launch Studio" 
            className="h-16 md:h-20"
          />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-6">
          <Link to="/about" className="text-secondary-light hover:text-primary font-medium transition-colors">
            About
          </Link>
          <Link to="/services" className="text-secondary-light hover:text-primary font-medium transition-colors">
            Services
          </Link>
          <Link to="/crm-system" className="text-secondary-light hover:text-primary font-medium transition-colors">
            CRM System
          </Link>
          <Link to="/faq" className="text-secondary-light hover:text-primary font-medium transition-colors">
            FAQ
          </Link>
          <Link to="/contact-old" className="text-secondary-light hover:text-primary font-medium transition-colors">
            Contact
          </Link>
          <Link to="/contact" className="btn-primary">
            Book a Quick Call
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-secondary"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
            {isMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white shadow-soft-lg absolute top-full left-0 right-0 py-4 animate-fade-in">
          <div className="container flex flex-col space-y-4">
            <Link 
              to="/about" 
              className="text-secondary-light hover:text-primary py-2 font-medium transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            <Link 
              to="/services" 
              className="text-secondary-light hover:text-primary py-2 font-medium transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Services
            </Link>
            <Link 
              to="/crm-system" 
              className="text-secondary-light hover:text-primary py-2 font-medium transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              CRM System
            </Link>
            <Link 
              to="/faq" 
              className="text-secondary-light hover:text-primary py-2 font-medium transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              FAQ
            </Link>
            <Link 
              to="/contact-old" 
              className="text-secondary-light hover:text-primary py-2 font-medium transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
            <Link 
              to="/contact-old" 
              className="btn-primary w-full text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              Book a Quick Call
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
